import React from "react";
import styles from "./Textarea.module.css";

function Textarea(props) {
  return (
    <>
      {props.label && <label className={styles.label} htmlFor={props.id}>{props.label}</label>}
      <textarea
        id={props.id}
        placeholder={props.placeholder}
        onChange={props.onChange}
        className={styles.textarea}
        name={props.name}
        {...props}
      />
    </>
  );
}

export default Textarea;
